export default ((id, options) => {
  options = Object.assign({
    animationDuration: 250,
    animationFunction: (start, end, time) => (1 - time) * start + time * end // Lerp.
  }, options);
  const view = document.getElementById(id);
  if (!view) {
    return;
  }
  const container = view.querySelector('.flex-roundabout,.flex-slider');
  const controlsPrevious = Array.from(view.querySelectorAll('[data-target="#' + id + '"][data-slide="prev"]'));
  const controlsNext = Array.from(view.querySelectorAll('[data-target="#' + id + '"][data-slide="next"]'));
  const indicators = Array.from(view.querySelectorAll('[data-target="#' + id + '"][data-slide-to]'));
  const items = Array.from(container.children);
  const itemCount = items.length;
  let itemIndex = 0;
  const images = container.querySelectorAll('img');
  for (const image of images) {
    image.style.pointerEvents = 'none';
  }
  const respondToResize = function () {
    const viewWidth = view.getBoundingClientRect().width;
    const scrollWidth = container.scrollWidth;
    const scrollMax = scrollWidth - viewWidth;

    // Check which indicators are usable.
    let offset = 0;
    let uselessAbove = null;
    for (let i = 0; i < itemCount; i++) {
      offset += items[i].offsetWidth;
      if (offset > scrollMax) {
        uselessAbove = i;
        break;
      }
    }

    // Disable useless indicators.
    if (uselessAbove !== null) {
      for (let i = 0; i < indicators.length; i++) {
        const indicator = indicators[i];
        const index = indicator.getAttribute('data-slide-to');
        if (Number.parseInt(index) > uselessAbove) {
          indicator.classList.add('disabled');
        }
      }
    }
  };
  window.addEventListener('resize', respondToResize);
  respondToResize();
  const respondToScroll = function () {
    // Check and update item index.
    let offset = 0;
    for (let i = 0; i < itemCount; i++) {
      offset += items[i].offsetWidth;
      if (offset > container.scrollLeft) {
        if (itemIndex === i) {
          // Stop running if the index hasn't changed.
          return;
        }
        itemIndex = i;
        break;
      }
    }

    // Activate the correct indicator.
    for (let i = 0; i < indicators.length; i++) {
      if (i === itemIndex) {
        indicators[i].classList.add('active');
      } else {
        indicators[i].classList.remove('active');
      }
    }
  };
  container.addEventListener('scroll', respondToScroll);
  respondToScroll();
  let isAnimating = false;
  let animationStartTime = null;
  let animationStartValue = 0;
  let animationTargetValue = 0;
  const startAnimation = function () {
    animationStartTime = Date.now();
    animationStartValue = container.scrollLeft;
    if (isAnimating) {
      return;
    }
    isAnimating = true;
    const animate = function () {
      const timeFactor = (Date.now() - animationStartTime) / options.animationDuration;
      if (timeFactor >= 1) {
        container.scrollLeft = animationTargetValue;
        isAnimating = false;
        return;
      }
      container.scrollLeft = options.animationFunction(animationStartValue, animationTargetValue, timeFactor);
      requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  };
  const slideTo = function (targetIndex) {
    // Wrap target index.
    if (targetIndex < 0) {
      slideTo(itemCount - targetIndex);
      return;
    }
    if (targetIndex >= itemCount) {
      slideTo(targetIndex - itemCount);
      return;
    }
    const sliderViewWith = view.getBoundingClientRect().width;
    const sliderScrollWidth = container.scrollWidth;
    const scrollMax = sliderScrollWidth - sliderViewWith;
    let animationTargetTemp = 0;
    for (let i = 0; i < targetIndex; i++) {
      const itemStyle = getComputedStyle(items[i]);
      animationTargetTemp += Math.ceil(items[i].getBoundingClientRect().width + parseFloat(itemStyle['margin-left']) + parseFloat(itemStyle['margin-right'])); //Script will cause weird edge cases When not ceiling the offsets
    }
    if (animationTargetTemp > scrollMax) {
      animationTargetTemp = scrollMax;
    }
    animationTargetValue = animationTargetTemp;
    startAnimation();
  };

  // Drag to slide. Only when the mouse is used in order to prevent issues on touch devices.
  const dragFactor = 1;
  const dragMinimum = 16;
  let mouseIsDown = false;
  let mouseHasDragged = false;
  let dragStartOffset = null;
  let dragStartScrollLeft = null;
  container.addEventListener('mousedown', event => {
    mouseIsDown = true;
    dragStartOffset = event.pageX - container.offsetLeft;
    dragStartScrollLeft = container.scrollLeft;
  });
  container.addEventListener('mousemove', event => {
    if (!mouseIsDown) {
      return;
    }
    let offset = event.pageX - container.offsetLeft - dragStartOffset;
    if (!mouseHasDragged) {
      if (Math.abs(offset) < dragMinimum) {
        return;
      }
      if (offset > 0) {
        dragStartScrollLeft += dragMinimum;
      } else {
        dragStartScrollLeft -= dragMinimum;
      }
    }
    mouseHasDragged = true;
    event.preventDefault();
    event.stopPropagation();
    container.style.cursor = 'grabbing';
    for (const item of items) {
      item.style.pointerEvents = 'none';
      item.style.userSelect = 'none';
    }
    container.scrollLeft = dragStartScrollLeft - offset * dragFactor;
  });
  // Cancel listening on mouse leave or up.
  const onMouseLeave = () => {
    if (mouseIsDown) {
      mouseIsDown = false;
      container.style.cursor = null;
      for (const item of items) {
        item.style.pointerEvents = null;
        item.style.userSelect = null;
      }
      if (mouseHasDragged) {
        mouseHasDragged = false;
      }
    }
  };
  container.addEventListener('mouseleave', onMouseLeave);
  container.addEventListener('mouseup', onMouseLeave);

  // Setup controls.
  for (const controlPrevious of controlsPrevious) {
    controlPrevious.addEventListener('click', function () {
      if (itemIndex > 0) {
        slideTo(itemIndex - 1);
      }
    });
  }
  for (const controlNext of controlsNext) {
    controlNext.addEventListener('click', function () {
      if (itemIndex < itemCount - 1) {
        slideTo(itemIndex + 1);
      }
    });
  }

  // Setup indicators.
  const setupIndicator = function (indicator) {
    indicator.addEventListener('click', function () {
      let targetIndex = indicator.getAttribute('data-slide-to');
      try {
        targetIndex = Number.parseInt(targetIndex);
      } catch (error) {
        return;
      }
      slideTo(targetIndex);
    });
  };
  for (const indicator of indicators) {
    setupIndicator(indicator);
  }
});